<template>
	<BaseCmsPage v-slot="{page}">
		<Body class="contact" />
		<CmsIntroContainer :page="page">
			<template #h1>
				<h1 v-if="page?.seo_h1">{{ page.seo_h1 }}</h1>
			</template>
		</CmsIntroContainer>

		<div class="wider-wrapper contact-wrapper">
			<div class="contact-cols">
				<div class="contact-col1">
					<div v-if="page?.content" class="cms-content" v-html="page.content" v-interpolation />
				</div>
				
				<div class="contact-col2">
					<div class="contact-us-form-cnt">
						<BaseCmsLabel class="contact-title contact-us-title" code="contact_us_title" tag="div" />

						<CmsInquiryForm />
					</div>
				</div>

				<div class="contact-col3">
					<div class="contact-info-cnt">
						<BaseCmsLabel class="contact-title contact-col3-title" code="contact_info" tag="div" />
						<BaseCmsLabel class="contact-info" code="footer_info" tag="div" />
					</div>
					<div class="contact-social-cnt">
						<BaseCmsLabel class="contact-title" code="follow_us" tag="div" />
						<BaseCmsLabel class="social contact-social" code="social_icons" tag="div" />
					</div>
				</div>
			</div>
		</div>

		<BaseLocationPoints v-slot="{items}">
			<ClientOnly>
				<CmsMap :items="items" />
			</ClientOnly>
		</BaseLocationPoints>
	</BaseCmsPage>
</template>

<style lang="less" scoped>
	.contact-wrapper{padding: 40px 0 80px;}
	.contact-cols{display: flex;}
	.contact-col1{
		width: 560px; flex-shrink: 0;
		.cms-content{width: 415px; padding: 0;}
		:deep(strong){font-weight: bold; color: var(--primaryColor);}
		:deep(p){padding-bottom: 3px;}
		:deep(a){text-decoration: underline;}
		.address{
			position: relative; padding-left: 33px; margin-bottom: 10px;
			&:before{.pseudo(18px,24px); background: url(assets/images/pin.svg) top left; background-size: contain; left: 0; top: 6px;}
			:deep(a){box-shadow: 0 1px 0 0 #55297A; font-weight: bold; text-decoration: none;}
		}
	}

	//COL2
	.contact-col2{width: 390px; flex-shrink: 0;}
	.contact-title{font-size: 24px; font-weight: 300; line-height: 1.2; color: var(--primaryColor); padding-bottom: 12px;}

	//COL3
	.contact-col3{
		padding-left: 170px; width: auto; flex-grow: 1; font-weight: normal;
		:deep(a){text-decoration: none; color: var(--textColor);}
		:deep(a):not([href^=tel]):hover{color: var(--primaryColor); text-decoration: underline;}
	}
	.contact-col3-title{padding-bottom: 7px;}
	.contact-social-cnt{padding-top: 25px;}
	
	@media (max-width: @l){
		.contact-col1{
			width: 500px;
			.cms-content{width: 390px;}
		}
		.contact-col2{width: 380px;}
		.contact-col3{padding-left: 100px;}
	}

	@media (max-width: @t){
		.contact-wrapper{padding: 35px 0 50px;}
		.contact-col1{
			width: 340px;flex-grow: 1; flex-shrink: 0;
			.cms-content{width: 300px;}
			.address{padding-left: 29px; margin-bottom: 10px;
				&:before{width: 17px; height: 22px;}
			}
		}
		.contact-col2{width: 290px; flex-shrink: 0; flex-grow: 1;}
		.contact-title{font-size: 22px; padding-bottom: 8px; }
		.contact-col3{
			padding-left: 50px; width: auto; 
			:deep(p){line-height: 30px;}
		}
	}

	@media (max-width: @tp){
		.contact-cols{flex-wrap: wrap;}
		.contact-wrapper{padding: 25px 0 38px;}
		.contact-col1,.contact-col2{width: calc(~"50% - 15px"); margin-right: 15px;}
		.contact-col2{margin-right: 0; margin-left: 15px;}
		.contact-col3{display: flex; width: auto; padding-top: 30px; padding-left: 0;}
		.contact-info-cnt{width: 50%;}
		.contact-social-cnt{padding-top: 0; margin-left: 15px;}
	}

	@media (max-width: @m){
		.contact-wrapper{padding: 20px 0 35px;}
		.contact-col1 .cms-content{width: 100%;}
		.contact-col1, .contact-col2{width: 100%;}
		.contact-col2{margin: 20px 0;}
		.contact-col1{order: 2;}
		.contact-col3{order: 1; padding-top: 15px;}
		.contact-col2{order: 3;}
		.contact-col3{flex-direction: column; padding: 0;}
		.contact-info-cnt{width: 100%;}
		.contact-social-cnt{margin: 14px 0 30px;}
		.contact-title{font-size: 18px; line-height: 1.2;}
		.contact-col3 :deep(p){line-height: 25px;}
	}
</style>